import * as React from "react"
import { Link } from "react-router-dom"
import ShoutbaseLogo from "../images/shoutbase-logo.svg"
import { MARKETING_SITE } from "../common/constants/app_consts"
import { isLoggedIn } from "../util/jwt_utils"

class LogoWrapper extends React.Component {
    render() {
        const redirectInternally = isLoggedIn()
        const { children } = this.props
        return redirectInternally ? (
            <Link to="/">{children}</Link>
        ) : (
            <a href={MARKETING_SITE}>{children}</a>
        )
    }
}

class Logo extends React.Component {
    render() {
        return (
            <div className="logo">
                <LogoWrapper>
                    <img src={ShoutbaseLogo} alt="Shoutbase Logo" />
                    <span>shoutbase</span>
                </LogoWrapper>
            </div>
        )
    }
}

export default Logo



// WEBPACK FOOTER //
// ./src/components/logo.jsx